export * from "./types";
export * from "./googlePay";
export * from "./stripe";

export const paymentOptions = {
    label: "me&u",
};
